import { Circle } from "@styled-icons/material";
import { SmallIcon } from "primitives/icons";
import { colors } from "styles";
import { FC } from "types";

export const CorrectAnswerCircle: FC = () => <SmallIcon icon={Circle} color={colors.brandGreen} />;
